module.exports = __webpack_public_path__ + "img/hotsell.b81556b1.svg";